export const DEFAULT_ITEM_PADDING = 10;
export const DEFAULT_OVERSCAN = 10;
export const DEFAULT_EFFECT = "fadeIn";
export const DEFAULT_ELEMENTS_PER_ROW = 1;
